import Popup, { type PopupProps } from "@client/layout/Popup/container";
import * as React from "react";

export type MapProps = PopupProps;
export default (props: MapProps) => {
  const containerStyle = React.useMemo(
    (): React.CSSProperties => ({
      maxWidth: "100%"
    }),
    []
  );
  return (
    <>
      {props.topMenu}

      <Popup {...props} entityStyle={containerStyle} />
    </>
  );
};
